"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilityAuthenticatedReactiveBase = void 0;
const react_1 = __importDefault(require("react"));
const hooks_1 = require("../../hooks");
const ReactiveBase_1 = __importDefault(require("@usereactify/search-internals/lib/components/basic/ReactiveBase"));
const UtilityAuthenticatedReactiveBase = (props) => {
    const reactiveBaseProps = (0, hooks_1.useReactiveBaseProps)();
    return react_1.default.createElement(ReactiveBase_1.default, Object.assign({}, reactiveBaseProps), props.children);
};
exports.UtilityAuthenticatedReactiveBase = UtilityAuthenticatedReactiveBase;
//# sourceMappingURL=UtilityAuthenticatedReactiveBase.js.map